module.exports = __webpack_public_path__ + "img/zakat-calculator-blank-400x200.png";